export default {
    currentImport: {},
    imports: [],
    accountCampaigns: [],
};
